export enum AdmissionGroupTagSort {
  VALUE_ASC = 'value',
  VALUE_DSC = '-value',
  CREATED_ASC = 'created',
  CREATED_DSC = '-created',
  TYPE_ASC = 'type',
  TYPE_DSC = '-type',
  TYPE_VALUE_DSC = '-type value',
}

export enum AdmissionGroupTagType {
  SYSTEM = 'SYSTEM',
  CUSTOM = 'CUSTOM',
}

export enum AdmissionGroupTagEvent {
  CREATED = 'ADMISSION_GROUP_TAG_CREATED',
  UPDATED = 'ADMISSION_GROUP_TAG_UPDATED',
  DELETED = 'ADMISSION_GROUP_TAG_DELETED',
}

export const ADMISSION_GROUP_TAG_MAX_LENGTH = 50

export enum AdmissionGroupTagSystemValue {
  BIRTHDAY = 'Birthday',
  SIGN_REQUEST = 'Sign request',
  BACHELORETTE = 'Bachelorette',
  BACHELOR = 'Bachelor',
  CORPORATE_EVENT = 'Corporate event',
  PER_OWNER = 'Per owner',
  PER_MANAGER = 'Per manager',
  NFU = 'NFU',
  PROMOTER = 'Promoter',
  PAID_CASH = 'Paid cash',
  PAID_VENMO = 'Paid Venmo',
  PAID_CASHAPP = 'Paid Cash App',
  GIRLS_NIGHT_OUT = 'Girls night out',
  PAID_ZELLE = 'Paid Zelle',
  PAID_VIA_WIRE = 'Paid via wire',
  PAID_VIA_BANK_TRANSFER = 'Paid via bank transfer',
  PAID_VIA_CRYPTO = 'Paid via crypto',
  FRAUD_LOW = 'Fraud - Low',
  FRAUD_MEDIUM = 'Fraud - Medium',
  FRAUD_HIGH = 'Fraud - High',
}

export const admissionGroupTagSystemReservedValues: AdmissionGroupTagSystemValue[] =
  Object.values(AdmissionGroupTagSystemValue)

export const admissionGroupTagSystemIcons: Record<
  AdmissionGroupTagSystemValue,
  string
> = {
  [AdmissionGroupTagSystemValue.BIRTHDAY]: '🎂',
  [AdmissionGroupTagSystemValue.SIGN_REQUEST]: '✍️',
  [AdmissionGroupTagSystemValue.BACHELORETTE]: '👰',
  [AdmissionGroupTagSystemValue.BACHELOR]: '🤵',
  [AdmissionGroupTagSystemValue.CORPORATE_EVENT]: '🏢',
  [AdmissionGroupTagSystemValue.PER_OWNER]: '👤',
  [AdmissionGroupTagSystemValue.PER_MANAGER]: '👤',
  [AdmissionGroupTagSystemValue.NFU]: '📋',
  [AdmissionGroupTagSystemValue.PROMOTER]: '📣',
  [AdmissionGroupTagSystemValue.PAID_CASH]: '💵',
  [AdmissionGroupTagSystemValue.PAID_VENMO]: '💸',
  [AdmissionGroupTagSystemValue.PAID_CASHAPP]: '💸',
  [AdmissionGroupTagSystemValue.GIRLS_NIGHT_OUT]: '👯',
  [AdmissionGroupTagSystemValue.PAID_ZELLE]: '💸',
  [AdmissionGroupTagSystemValue.PAID_VIA_WIRE]: '🏦',
  [AdmissionGroupTagSystemValue.PAID_VIA_BANK_TRANSFER]: '🏦',
  [AdmissionGroupTagSystemValue.PAID_VIA_CRYPTO]: '₿',
  [AdmissionGroupTagSystemValue.FRAUD_LOW]: '🛡️',
  [AdmissionGroupTagSystemValue.FRAUD_MEDIUM]: '⚠️',
  [AdmissionGroupTagSystemValue.FRAUD_HIGH]: '🚨',
}

export const admissionGroupTagSystemBackgroundColors: Record<
  AdmissionGroupTagSystemValue,
  string
> = {
  [AdmissionGroupTagSystemValue.BIRTHDAY]: '#0095ff', //blue500
  [AdmissionGroupTagSystemValue.SIGN_REQUEST]: '#0095ff',
  [AdmissionGroupTagSystemValue.BACHELORETTE]: '#0095ff',
  [AdmissionGroupTagSystemValue.BACHELOR]: '#0095ff',
  [AdmissionGroupTagSystemValue.CORPORATE_EVENT]: '#0095ff',
  [AdmissionGroupTagSystemValue.PER_OWNER]: '#0095ff',
  [AdmissionGroupTagSystemValue.PER_MANAGER]: '#0095ff',
  [AdmissionGroupTagSystemValue.NFU]: '#0095ff',
  [AdmissionGroupTagSystemValue.PROMOTER]: '#cc329e', //pink600
  [AdmissionGroupTagSystemValue.PAID_CASH]: '#0eaa4d', //green700
  [AdmissionGroupTagSystemValue.PAID_VENMO]: '#0eaa4d',
  [AdmissionGroupTagSystemValue.PAID_CASHAPP]: '#0eaa4d',
  [AdmissionGroupTagSystemValue.GIRLS_NIGHT_OUT]: '#0095ff',
  [AdmissionGroupTagSystemValue.PAID_ZELLE]: '#0eaa4d',
  [AdmissionGroupTagSystemValue.PAID_VIA_WIRE]: '#0eaa4d',
  [AdmissionGroupTagSystemValue.PAID_VIA_BANK_TRANSFER]: '#0eaa4d',
  [AdmissionGroupTagSystemValue.PAID_VIA_CRYPTO]: '#0eaa4d',
  [AdmissionGroupTagSystemValue.FRAUD_LOW]: '#0eaa4d', //green700
  [AdmissionGroupTagSystemValue.FRAUD_MEDIUM]: '#d66700', //orange700
  [AdmissionGroupTagSystemValue.FRAUD_HIGH]: '#b42d2d', //red700
}

export const admissionGroupTagSystemTextColors: Record<
  AdmissionGroupTagSystemValue,
  string
> = {
  [AdmissionGroupTagSystemValue.BIRTHDAY]: '#ffffff',
  [AdmissionGroupTagSystemValue.SIGN_REQUEST]: '#ffffff',
  [AdmissionGroupTagSystemValue.BACHELORETTE]: '#ffffff',
  [AdmissionGroupTagSystemValue.BACHELOR]: '#ffffff',
  [AdmissionGroupTagSystemValue.CORPORATE_EVENT]: '#ffffff',
  [AdmissionGroupTagSystemValue.PER_OWNER]: '#ffffff',
  [AdmissionGroupTagSystemValue.PER_MANAGER]: '#ffffff',
  [AdmissionGroupTagSystemValue.NFU]: '#ffffff',
  [AdmissionGroupTagSystemValue.PROMOTER]: '#ffffff',
  [AdmissionGroupTagSystemValue.PAID_CASH]: '#ffffff',
  [AdmissionGroupTagSystemValue.PAID_VENMO]: '#ffffff',
  [AdmissionGroupTagSystemValue.PAID_CASHAPP]: '#ffffff',
  [AdmissionGroupTagSystemValue.GIRLS_NIGHT_OUT]: '#ffffff',
  [AdmissionGroupTagSystemValue.PAID_ZELLE]: '#ffffff',
  [AdmissionGroupTagSystemValue.PAID_VIA_WIRE]: '#ffffff',
  [AdmissionGroupTagSystemValue.PAID_VIA_BANK_TRANSFER]: '#ffffff',
  [AdmissionGroupTagSystemValue.PAID_VIA_CRYPTO]: '#ffffff',
  [AdmissionGroupTagSystemValue.FRAUD_LOW]: '#ffffff',
  [AdmissionGroupTagSystemValue.FRAUD_MEDIUM]: '#ffffff',
  [AdmissionGroupTagSystemValue.FRAUD_HIGH]: '#ffffff',
}

export const admissionGroupTagSystemDescriptions: Partial<
  Record<AdmissionGroupTagSystemValue, string>
> = {
  [AdmissionGroupTagSystemValue.FRAUD_LOW]:
    'Auto-tagged by the system after a successful Stripe payment when fraud risk score is between 0 and 30.',
  [AdmissionGroupTagSystemValue.FRAUD_MEDIUM]:
    'Auto-tagged by the system after a successful Stripe payment when fraud risk score is between 31 and 69.',
  [AdmissionGroupTagSystemValue.FRAUD_HIGH]:
    'Auto-tagged by the system after a successful Stripe payment when fraud risk score is between 70 and 100.',
}

export const getAdmissionGroupTagSystemProps = (
  value: AdmissionGroupTagSystemValue
) => ({
  value,
  backgroundColor: admissionGroupTagSystemBackgroundColors[value],
  textColor: admissionGroupTagSystemTextColors[value],
  icon: admissionGroupTagSystemIcons[value],
  type: AdmissionGroupTagType.SYSTEM,
})

export const admissionGroupFlagsDbKeyToSystemValue: Record<
  string,
  AdmissionGroupTagSystemValue
> = {
  birthday: AdmissionGroupTagSystemValue.BIRTHDAY,
  sign_request: AdmissionGroupTagSystemValue.SIGN_REQUEST,
  bachelorette: AdmissionGroupTagSystemValue.BACHELORETTE,
  bachelor: AdmissionGroupTagSystemValue.BACHELOR,
  corporate_event: AdmissionGroupTagSystemValue.CORPORATE_EVENT,
  per_owner: AdmissionGroupTagSystemValue.PER_OWNER,
  per_manager: AdmissionGroupTagSystemValue.PER_MANAGER,
  nfu: AdmissionGroupTagSystemValue.NFU,
  promoter: AdmissionGroupTagSystemValue.PROMOTER,
  paid_cash: AdmissionGroupTagSystemValue.PAID_CASH,
  paid_venmo: AdmissionGroupTagSystemValue.PAID_VENMO,
  paid_cashapp: AdmissionGroupTagSystemValue.PAID_CASHAPP,
  girls_night_out: AdmissionGroupTagSystemValue.GIRLS_NIGHT_OUT,
  paid_zelle: AdmissionGroupTagSystemValue.PAID_ZELLE,
  paid_via_wire: AdmissionGroupTagSystemValue.PAID_VIA_WIRE,
  paid_via_bank_transfer: AdmissionGroupTagSystemValue.PAID_VIA_BANK_TRANSFER,
  paid_via_crypto: AdmissionGroupTagSystemValue.PAID_VIA_CRYPTO,
}

export const admissionGroupTagSystemValueToFlagsDbKey: Partial<
  Record<AdmissionGroupTagSystemValue, string>
> = {
  [AdmissionGroupTagSystemValue.BIRTHDAY]: 'birthday',
  [AdmissionGroupTagSystemValue.SIGN_REQUEST]: 'sign_request',
  [AdmissionGroupTagSystemValue.BACHELORETTE]: 'bachelorette',
  [AdmissionGroupTagSystemValue.BACHELOR]: 'bachelor',
  [AdmissionGroupTagSystemValue.CORPORATE_EVENT]: 'corporate_event',
  [AdmissionGroupTagSystemValue.PER_OWNER]: 'per_owner',
  [AdmissionGroupTagSystemValue.PER_MANAGER]: 'per_manager',
  [AdmissionGroupTagSystemValue.NFU]: 'nfu',
  [AdmissionGroupTagSystemValue.PROMOTER]: 'promoter',
  [AdmissionGroupTagSystemValue.PAID_CASH]: 'paid_cash',
  [AdmissionGroupTagSystemValue.PAID_VENMO]: 'paid_venmo',
  [AdmissionGroupTagSystemValue.PAID_CASHAPP]: 'paid_cashapp',
  [AdmissionGroupTagSystemValue.GIRLS_NIGHT_OUT]: 'girls_night_out',
  [AdmissionGroupTagSystemValue.PAID_ZELLE]: 'paid_zelle',
  [AdmissionGroupTagSystemValue.PAID_VIA_WIRE]: 'paid_via_wire',
  [AdmissionGroupTagSystemValue.PAID_VIA_BANK_TRANSFER]:
    'paid_via_bank_transfer',
  [AdmissionGroupTagSystemValue.PAID_VIA_CRYPTO]: 'paid_via_crypto',
}
